<!-- level 1 -->
<ul class="p-t-1 menu-component"
    [ngClass]="[component.color || '', component.text_style || '']">

    @for (item of component.menu; track $index; let i = $index) {
    <li class="p-t-1 p-b-2">
        <!-- link -->
        <div [zippyOpen]="[uid, i]">
            <href [link]="item.link">
                <span class="link underline-h"
                      [ngClass]="[item.link_class || component.link_class || 'link link-3', item.color || '']"
                      *iCms="'text' of item">{{ item.text }}</span>
            </href>
        </div>
        <!-- contents -->
        @if (client.isCms || item.components?.length) {
        <div [zippy]="[uid, i]">
            <div class="p-l-1 b-b m-t-1 fs-4">
                <icms-outlet [components]="item.components ">
                </icms-outlet>
            </div>
        </div>
        }
    </li>
    }
</ul>